import React, { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import styled from 'styled-components';
import {money} from "../../../services/format";
import {CTA} from "../../general/Button";
import config from "../../../config/channels";
import { TChannel } from "../../../contexts/operator/operator-context";
import { Delivery, Catering, Venues } from "../../../contexts/site/site-context";
import useOperatorContext from "../../../contexts/operator/useOperatorContext";
import useSiteContext from "../../../contexts/site/useSiteContext";
import {useNavigate} from "react-router-dom";
import TinyModal from "../../general/TinyModal";

type DeliveryInfoModalProps = {
    channel: TChannel;
    show: boolean;
    onHide: () => void;
};

const DeliveryInfoModal = ({
    channel,
    show,
    onHide,
}: DeliveryInfoModalProps) => {

    const navigate = useNavigate();
    const operatorContext = useOperatorContext();
    const siteContext = useSiteContext();

    useEffect(() => {
        document.getElementById('delivery-info-modal')?.classList.add('anim-enter');

        return () => {
            document.getElementById('delivery-info-modal')?.classList.remove('anim-enter');
        };
    }, [show]);

    if ( channel !== config.delivery.name && channel !== config.catering.name && channel !== config.venues.name ) {
        return null;
    }

    let displayName = config[channel]['displayName'];

    if ( channel === 'catering' ) {
        displayName = operatorContext.operator?.theme.v4.catering_label ?? 'Catering';
    }

    const backButtonClick = () => {
        localStorage.removeItem('postcode');
        localStorage.removeItem('delivery-venue');
        navigate(`/`);
    };

    const renderFooter = () => (
        <>
            <CTA secondary buddies
                 onClick={() => backButtonClick()}>
                <span>Go back</span>
            </CTA>
            <CTA buddies
                 onClick={onHide}>
                <span>Continue</span>
            </CTA>
        </>
    );

    const deliveryFrom = () => {
        return (
            siteContext.timeslots && siteContext.timeslots.length > 0 ? (
                <p>Next available time: { siteContext.timeslots[0].name }</p>
            ) : null
        );
    };

    const deliveryFee = () => {
        return (
            (siteContext.site?.channels?.[channel] as Delivery | Catering | Venues)?.delivery_fee_summary ? (
                <p>Delivery fee: { (siteContext.site?.channels?.[channel] as Delivery | Catering | Venues)?.delivery_fee_summary }</p>
            ) : null
        );
    };

    return (
        <TinyModal
            show={show}
            onHide={onHide}
            header={displayName}
            footer={renderFooter()}
            modalID={'delivery-info-modal'}
        >
           <>
               <div className='modal__inset'>
                { deliveryFrom() }
                { siteContext.site?.min_order ? (
                    <p>Minimum spend: { money(siteContext.site?.min_order, operatorContext.operator?.ccy, operatorContext.operator?.locale) }</p>
                ) : null }
                { siteContext.site?.max_order ? (
                    <p>Maximum spend: { money(siteContext.site?.max_order, operatorContext.operator?.ccy, operatorContext.operator?.locale) }</p>
                ) : null }
                { deliveryFee() }
               </div>
           </>
        </TinyModal>
    );
};

export default DeliveryInfoModal;
